import { render, staticRenderFns } from "./view-line-answer.vue?vue&type=template&id=1172674d&scoped=true&"
import script from "./view-line-answer.vue?vue&type=script&lang=js&"
export * from "./view-line-answer.vue?vue&type=script&lang=js&"
import style0 from "./view-line-answer.vue?vue&type=style&index=0&id=1172674d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172674d",
  null
  
)

export default component.exports